export const treatedConditions = [
  {
    condition: `Common Cold`,
    definition: [
      'An upper respiratory infection (URI) refers to an infection in your nose, throat, and sinuses (the hollow air spaces within the bones surrounding the nose).',
      'Common symptoms are a runny nose, sinus congestion, and sore throat. Symptoms are usually worse at night and get better within a week.',
      'URIs are most often caused by a virus. These viruses are easily spread through the air or on things you touch, like a handrail or doorknob.'
    ]
  },
  {
    condition: `Sinus Infection`,
    definition: [
      'Sinusitis is an infection of the hollow air spaces within the bones surrounding the nose. It is typically caused by a virus or bacteria.',
      'Common symptoms include pain or pressure in your face, sinus congestion, and runny nose.',
      'Most cases of sinusitis go away on their own after about a week. Sometimes they last longer and need to be treated with antibiotics.'
    ]
  },
  {
    condition: `Seasonal Allergies`,
    definition: [
      'Hay fever, also called allergic rhinitis [rine-EYE-tis], is your body’s way getting rid of pollen, grass, dust, mold or other particles in the air (allergens).',
      "Symptoms of hay fever include sneezing, coughing, itchy eyes, and runny nose. They usually start when the seasons are changing (because new pollen and dust is in the air) or when traveling to new places (because your body isn't used to the allergens there)."
    ]
  },
  {
    condition: `Sore Throat`,
    definition: [
      'Viral pharyngitis [fair-en-JIE-tiss] is the medical name for a sore throat.',
      'It is often caused by a virus that makes the throat red and painful. It can also make it hard to swallow, block up your sinuses, and cause a cough.',
      'You may have a sore throat when you have a stuffy or runny nose and a cough. Symptoms are usually worse at night and last less than a week.'
    ]
  },
  {
    condition: `Flu`,
    definition: [
      'The flu is caused by the influenza virus. It usually causes the same type of symptoms and is always very contagious. The type of virus that causes the flu is often different each year.',
      'Most people with the flu get better within 5 to 7 days with home remedies and medications you can find at the drug or grocery store.',
      'Some people (babies, older people, and people with other medical problems) might require more intense treatment or even hospitalization to recover.',
      'You can avoid the flu by wearing a mask, washing your hands, and avoiding close contact with other people.'
    ]
  },
  {
    condition: `Asthma`,
    definition: [
      'Asthma is a chronic (long-term) disease that affects your airways. Asthma can cause your airways to narrow and swell and produce extra mucus. This can make breathing difficult and trigger coughing, wheezing and shortness of breath.',
      "Asthma can't be cured, but its symptoms can be controlled."
    ]
  },
  {
    condition: `Headache`,
    definition: [
      'A headache is just that – an ache in your head. It can happen in any part of your head, for example, behind the eyes, around the ears, or in the upper part of your neck.',
      "Some headaches don't have specific, obvious causes. They can be tied to stress, not drinking enough water, caffeine withdrawal, or menstrual periods. Headaches can last anywhere from 30 minutes to several days.",
      'Headaches can be treated with over-the-counter pain medicine such as ibuprofen, aspirin, or acetaminophen.  Relaxation, sleep, and diet changes can also help.'
    ]
  },
  {
    condition: `Pink Eye`,
    definition: [
      'Conjunctivitis [con-junk-tiv-EYE-tiss] is the medical term for pink eye. Pink eye is an inflammation or infection of the conjunctiva [con-junk-TIE-vah] – the transparent membrane that lines the eyelid and covers the white part of the eyeball.',
      'Pink eye is commonly caused by a bacterial or viral infection. It is passed easily from person to person. The best way to avoid it is to wash your hands often.'
    ]
  },
  {
    condition: `Sty`,
    definition: [
      'A sty is a red, painful lump on or in the eyelid that may look like a boil or a pimple. Stys are caused by blocked glands in the eyelid that become inflamed. Although they are painful, they usually resolve on their own after a few days.',
      'If you have a sty, don’t wear contact lenses. Place warm washcloths on the area help to relieve any pain or discomfort.'
    ]
  },
  {
    condition: `Acid Reflux and Heartburn`,
    definition: [
      'Gastroesophageal [gas-troh-eh-soff-eh-GEE-uhl] reflux disease, or GERD is when stomach acid leaks into your esophagus [eh-SOFF-eh-gus], or food tube.',
      'Stomach acid irritates the lining of your esophagus and causes a burning sensation in your throat or chest.',
      'It can also feel like something is stuck in your throat, causing burping or nausea.',
      'GERD is often triggered by overeating or eating spicy or acidic foods. It can damage your esophagus over time if not treated.'
    ]
  },
  {
    condition: `Stomach Virus/ Stomach Flu`,
    definition: [
      'Gastroenteritis [gas-troh-en-ter-EYE-tiss] is an infection in the stomach and intestines (gut). It can be caused by bacteria or viruses in food or drinks.',
      'Common symptoms include diarrhea, nausea, vomiting, belly pain, loss of appetite, and fevers.',
      'This condition usually gets better within a week with rest and lots of fluids.'
    ]
  },
  {
    condition: `Hemorrhoids`,
    definition: [
      'Hemorrhoids [HEM-eh-royds], also called piles, are swollen and inflamed veins in your anus and lower rectum. Hemorrhoids may result from straining during bowel movements or from the increased pressure on these veins during pregnancy.'
    ]
  },
  {
    condition: `Urinary Tract Infection/ UTI Bladder Infection`,
    definition: [
      'A urinary tract infection (UTI) is an infection in any part of your urinary system, usually in the bladder.',
      "It's often caused by not drinking enough water, taking antibiotics, poorly treated diabetes, or poor hygiene – though sometimes the cause is unknown.",
      'Common symptoms include a burning sensation with while peeing, a strong urge to pee, pressure in the lower belly, or low back pain. Fevers, vomiting, or severe back pain are uncommon.',
      'UTIs are common and easily treated. Once treatment starts, the symptoms tend to improve in 1 to 2 days.'
    ]
  },
  {
    condition: `Vaginal Yeast Infection`,
    definition: [
      'A vaginal yeast infection is caused by a fungus called Candida that exists naturally in the vagina but has grown a little out of control.',
      'It can be caused by poor hygiene, diabetes, antibiotics — though sometimes the cause is unknown.',
      'Common symptoms include itching inside and outside of the vagina. You may have a thick, white discharge for a few days too. With treatment, symptoms should start to get better in a couple days.'
    ]
  },
  {
    condition: `New Low Back Pain`,
    definition: [
      'Low back pain is common. Most people have it at some time in their life.',
      'Low back pain can be acute (new or unusual, or caused by an injury) or chronic (long term). It may also be caused by an illness or other medical condition.',
      'Symptoms of low back pain include stiffness or decreased movement of the lower back. You may also have a hard time standing straight.',
      'Treatment will vary depending on the cause. '
    ]
  }
];

export const conditionDefinitionsScreen = {
  title: 'More information: Conditions treated with E-Visits'
};

export const notificationsButtonsText = (hasChannelsEnabled: boolean) => {
  switch (hasChannelsEnabled) {
    case true:
      return {
        title: "We'll notify you when your treatment plan is ready.",
        topButton: 'Manage notifications',
        bottomButton: 'Close'
      };
    default:
      return {
        title:
          'Check back for your results. If you would like to be notified when your treatment plan is ready please setup notifications.',
        topButton: 'Setup notifications',
        bottomButton: "No, I'll check for updates manually"
      };
  }
};

export const eVisitSuccessText = {
  title: 'Your E-Visit has been sent to the provider for review',
  estimatedTime: 'Estimated response time is 1-2 hours*',
  footer: [
    '* Estimations based on normal business hours and may vary at night.',
    'If you need assistance please contact us at'
  ],
  phone: '(801) 442-2610'
};
